import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/ScrollToTopOnRouteChange.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/helpers/fonts.js\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"style\":[\"italic\",\"normal\"],\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserratFamily\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/helpers/fonts.js\",\"import\":\"Lora\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"style\":[\"italic\",\"normal\"]}],\"variableName\":\"loraFamily\"}");
;
import(/* webpackMode: "eager" */ "/app/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AdScripts/AdScripts.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GlobalErrorBoundary/GlobalErrorBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GlobalErrorBoundary/GlobalErrorHandler.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image/Image.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Provider.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/ScrollToTop/ScrollToTop.js");
;
import(/* webpackMode: "eager", webpackExports: ["UTMCookie"] */ "/app/src/components/UTMCookie/UTMCookie.js");
;
import(/* webpackMode: "eager" */ "/app/src/services/RouteService.js");
